// react
import React from 'react'

//hooks
import { useRetractSidebar } from '_hooks'

// components
import EntityEditForm from '_components/entity-edit-form/index.jsx'
import MultiValueInput from '_components/multi-value-input'

const RegionPage = (props) => {
  useRetractSidebar()

  return (
    <div id="region-page">
      <EntityEditForm
        entities="regions"
        id={props.match.params.id}
        fields={[
          { name: 'name' },
          { name: 'description' },
          { name: 'countries' },
          { name: 'subdivisions' },
          // { name: 'cities' }, // this field is treated differently inside the component\
        ]}
        additionalRender={(item, schema, onChange) => (
          <div>
            <div className="st-select__label-wrapper">
              <label className="st-select__label">Cities</label>
              <span className="st-select__caption">{schema?.cities?.description}</span>
            </div>
            <MultiValueInput
              className="st-entity-edit-form__multivalue mb-8"
              values={item?.cities}
              onChange={(value) => onChange(item, 'cities', value)}
              pasteRegex={/[,;] */}
            />
          </div>
        )}
        resource="Regions"
      />
    </div>
  )
}

export default RegionPage
